import React from 'react';
import BuildingRowHeader from '../../../components/BuildingRowHeader/BuildingRowHeader';
import { RenderedProps } from '../../../components/collapsibleTable/models';
import styles from './PartnerBuildingRowHeader.module.scss';

type PartnerBuildingRowHeaderComponentProps = RenderedProps;

const PartnerBuildingRowHeaderComponent = (props: PartnerBuildingRowHeaderComponentProps): React.ReactElement => {
    return <BuildingRowHeader {...props} additionalNameClassName={styles.buildingName} />;
};

export default PartnerBuildingRowHeaderComponent;
